module.exports = __webpack_public_path__ + "static/first-68d30ab9c45eceed43ab38d3fd46d164.svg";